/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.0.1
 */

import IWidgetCostsTranslation from '@modules/internationalization/types/pages/dashboard/widgetCosts';
import { EWidgetCostsChart } from '@pages/PageDashboard/components/Widgets/WidgetCosts/types/widgetCostsType';

const initTranslationWidgetCosts: IWidgetCostsTranslation = {
    preliminaryData: '',
    chart: {
        [EWidgetCostsChart.ONE_TIME_CHARGES]: '',
        [EWidgetCostsChart.OTHER_RECURRING_CHARGES]: '',
        [EWidgetCostsChart.RECURRING_CHARGES_FOR_RATE_PLAN]: '',
        [EWidgetCostsChart.TRAFFIC_CHARGES_AT_HOME_MACRO_REGION_AND_NOT_IN_HOME_REGION]: '',
        [EWidgetCostsChart.TRAFFIC_CHARGES_AT_HOME_REGION]: '',
        [EWidgetCostsChart.TRAFFIC_CHARGES_AT_OUT_HOME_MACRO_REGION]: '',
        [EWidgetCostsChart.TRAFFIC_CHARGES_AT_ROAMING]: '',
    },
    link: '',
    emptyMsg: '',
    emptyMsgBefore: '',
    errorMsg: '',
    title: '',
};

export default initTranslationWidgetCosts;
